'use client'
// import { Icon } from "trimble-terra/Icon"
import { Icon } from "trimble-terra"

export default Icon